import { v2_useCmsPages } from '@crocodille/common';
import Link from 'next/link';
import React from 'react';
import * as routing from '../../routing';

import styles from './cms-page-list.module.scss';

export interface CmsPageListProps {
  readonly section?: string;
}

export const CmsPageListItem: React.FC<{
  readonly title: string;
  readonly href: string;
}> = ({ title, href }) => {
  return (
    <li className={styles.item}>
      <Link href={href} className={styles.link} prefetch={false}>
        {title}
      </Link>
    </li>
  );
};

const CmsPageList: React.FC<React.PropsWithChildren<CmsPageListProps>> = ({
  section,
  children,
}) => {
  const { data: pages } = v2_useCmsPages(section);

  return (
    <ul className={styles.container}>
      {pages?.map?.((page) => (
        <CmsPageListItem
          key={page.id}
          title={page.name}
          href={routing.cmsPages({ page: page.slug })}
        />
      )) ?? null}
      {children}
    </ul>
  );
};

export default CmsPageList;
